export const bySortOrder = (sortable1: { SortOrder: number }, sortable2: { SortOrder: number }) => {
  return sortable1.SortOrder - sortable2.SortOrder
}
